<template>
    <FormSection :application="referral.application">
        <template #content>
            <section class="p-5 d-flex flex-column text-center text-primary" v-if="isTransferInProgress">
                <i class="fas fa-exchange-alt fa-7x me-2 animated slow flash infinite"></i>
                <div class="big-text mt-1">
                    <b>Creating Referral in Progress...</b>
                </div>
            </section>
            <div class="row mx-2 px-3 pt-3">
                <div class="form-group d-flex flex-column ps-lg-4 col-md-3">
                    <label for="form-check-label pb-1"
                        >Classify Patient as Non-Admit <span class="text-danger">*</span></label
                    >
                    <div class="d-flex flex-row">
                        <div class="form-check custom-radio">
                            <input
                                type="radio"
                                id="non-admit-no "
                                name="non-admit"
                                class="form-check-input"
                                v-model="isNonAdmit"
                                :value="false"
                            />
                            <label class="form-check-label" for="non-admit-no">
                                <span class="me-1">No</span>
                            </label>
                        </div>
                        <div class="form-check custom-radio ps-4 ms-4">
                            <input
                                type="radio"
                                id="non-admit-yes"
                                name="non-admit"
                                class="form-check-input"
                                :value="true"
                                v-model="isNonAdmit"
                            />
                            <label class="form-check-label" for="non-admit-yes">
                                <span class="me-1">Yes</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="form-group col-lg-2 ps-lg-0 me-lg-3 col-md-3">
                    <label for="task-name"> Refer To: </label>
                    <span class="text-danger">*</span>
                    <select
                        id="task-name"
                        class="form-select"
                        v-model="referTo"
                        @change="updateBranches"
                        @blur="v$.referTo.$touch"
                    >
                        <option :value="null">Select Solution</option>
                        <option v-for="(agency, index) of referableAgencyServices" :key="index" :value="agency">
                            <div v-show="agency.show">
                                {{ agency.name }}
                            </div>
                        </option>
                    </select>
                    <span v-if="v$.referTo.$error" class="field-invalid">Field is required.</span>
                </div>
                <div class="form-group col-lg-2 col-md-3">
                    <label for="task-name">Branch: </label>
                    <span class="text-danger">*</span>
                    <select
                        id="task-name"
                        class="form-select"
                        v-model="selectedBranch"
                        :disabled="!referTo"
                        @blur="v$.selectedBranch.$touch"
                    >
                        <option :value="null">Select Branch</option>
                        <optgroup
                            v-for="provider of providerList"
                            :label="provider.name"
                            :value="provider"
                            :key="provider.name"
                        >
                            <option v-for="branch of provider.branches" :key="branch.name" :value="branch">
                                {{ branch.name }}
                            </option>
                        </optgroup>
                    </select>
                    <span v-if="v$.selectedBranch.$error" class="field-invalid">Field is required.</span>
                </div>
            </div>
            <div class="row mx-2 px-3 pb-2">
                <div :class="`form-group ps-lg-4 pe-lg-5 col-md-3 ${isNonAdmit == true ? 'd-block' : 'd-none'}`">
                    <label for="non-admit-date"> Non-Admit Date: </label>
                    <span class="text-danger">*</span>
                    <DatePicker :getDate="updateNonAdmitDate">
                        <div class="input-group date datepickerInput">
                            <input
                                name="nonAdmitDate"
                                type="text"
                                class="form-control"
                                placeholder="MM/DD/YYYY"
                                v-model="nonAdmitDate"
                                autocomplete="off"
                                :disabled="!isNonAdmit"
                                @blur="v$.nonAdmitDate.$touch"
                            />
                            <div class="input-group-addon input-group-append">
                                <div class="input-group-text">
                                    <i class="fa fa-calendar"></i>
                                </div>
                            </div>
                        </div>
                    </DatePicker>
                    <span v-if="v$.nonAdmitDate.$error" class="field-invalid">Field is required.</span>
                </div>
                <div :class="`form-group ps-lg-4 pe-lg-5 col-md-3  ${isNonAdmit == true ? 'd-block' : 'd-none'}`">
                    <label for="non-admit-reason"> Non-Admit Reason: </label>
                    <span class="text-danger">*</span>
                    <select
                        id="non-admit-reason"
                        class="form-select"
                        v-model="selectedNonAdmitReason"
                        :disabled="!isNonAdmit"
                        @blur="v$.selectedNonAdmitReason.$touch"
                    >
                        <option value="">Select Non-Admit Reason</option>
                        <option
                            v-for="nonAdmitReason of nonAdmitReasons"
                            :key="nonAdmitReason.name"
                            :value="nonAdmitReason"
                        >
                            {{ nonAdmitReason.name }}
                        </option>
                    </select>
                    <span v-if="v$.selectedNonAdmitReason.$error" class="field-invalid">Field is required.</span>
                </div>
            </div>
        </template>
    </FormSection>
    <div class="text-center pt-3">
        <button type="button" class="btn btn-primary btn-md au-target" @click="convertToRefer()" au-target-id="2039">
            Refer
        </button>
        <button
            type="button"
            class="btn btn-outline-secondary btn-md ms-2 au-target"
            @click="closeNonAdmitForm()"
            au-target-id="2040"
        >
            Cancel
        </button>
    </div>
</template>

<script src="./TransferPatientForm.ts"></script>
